import { Model as e } from "../../../model.js";
class d extends e {
  constructor(s) {
    super(), this.id = s.id, this.status = s.status, this.distance = s.distance ?? -1, this.name = s.name, this.address = s.address, this.phone = s.phone, this.zones = s.zones ?? [], this.alternativeTimes = s.alternativeTimes ?? [], this.alternativePeople = s.alternativePeople ?? [];
  }
  equals(s) {
    return s.id === this.id;
  }
}
export {
  d as BookingAvailabilityItemModel
};
//# sourceMappingURL=bookingAvailabilityItem.model.js.map
